module.exports = __webpack_public_path__ + "img/indeed.b9125607.png";